module.exports = __webpack_public_path__ + "static/media/app-store.756161e1.png";